<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_iv"></a>St. Martin’s Paperbacks Titles<br/><strong>By Caitlin Kittredge</strong></p>
<p class="para"> </p>
<p class="center-para"><em>Street Magic</em></p>
<p class="para"> </p>
<p class="center-para"><em>Witch Craft</em></p>
<p class="para"> </p>
<p class="center-para"><em>Second Skin</em></p>
<p class="para"> </p>
<p class="center-para"><em>Pure Blood</em></p>
<p class="para"> </p>
<p class="center-para"><em>Night Life</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?e0c36744